module.exports = __webpack_public_path__ + "img/manifest.c07ac764.png";